/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { Table, Toggle } from 'rsuite';
import { TogglesStatus } from '../styles';

const { Cell } = Table;

function CelulaAcao({ setProfissional, setDesabilitar, rowData, ...props }) {
  return (
    <Cell {...props}>
      <TogglesStatus>
        <Toggle
          value={rowData.desabilitado}
          checked={rowData.desabilitado === 'Sim'}
          onChange={() => {
            setDesabilitar((prev) => (prev === 'Sim' ? 'Não' : 'Sim'));
            setProfissional(rowData);
          }}
        />
      </TogglesStatus>
    </Cell>
  );
}

CelulaAcao.propTypes = {
  rowData: PropTypes.object,
  onFavoritar: PropTypes.func,
  dataKey: PropTypes.string.isRequired,
  setDesabilitar: PropTypes.func.isRequired,
  setProfissional: PropTypes.func.isRequired,
};

CelulaAcao.defaultProps = {
  rowData: {},
  onFavoritar: null,
};

export default CelulaAcao;
